import React from 'react';

interface SelectAllCheckboxProps {
  selectAll: boolean;
  nativeLockUsd: number;
  onChange: () => void;
}

export const SelectAllCheckbox: React.FC<SelectAllCheckboxProps> = ({
  selectAll,
  nativeLockUsd,
  onChange,
}) => {
  return (
    <div className="mb-4 p-3 sm:p-3.5 bg-gray-700 rounded-lg">
      <div className="flex items-center space-x-2 sm:space-x-3">
        <input
          type="checkbox"
          checked={selectAll}
          onChange={onChange}
          style={{ width: '24px', height: '24px', minWidth: '24px', minHeight: '24px' }}
          className="text-green-600 bg-gray-600 border-gray-500 rounded focus:ring-green-500 flex-shrink-0"
        />
        <div className="min-w-0 flex-1">
          <h3 className="font-medium text-white text-sm ">Select All Tokens</h3>
          <p className="text-xs text-gray-400 mt-0.5">
            Select all tokens across all chains (keeps ${nativeLockUsd} native tokens for gas)
          </p>
        </div>
      </div>
    </div>
  );
};

